import { useState } from 'react';
import SiteContext from './SiteContext'

const SiteState = ({ children }) => {
    const [visitIndex, setVisitIndex] = useState(sessionStorage.getItem("visit")??0);
    const [currLatLng, setCurrLatLng] = useState({ lat: 0, lng: 0 });

    const siteValues = {
        visitIndex,
        currLatLng,
        setVisitIndex,
        setCurrLatLng
    };
    return (
        <SiteContext.Provider value={siteValues}>
            {children}
        </SiteContext.Provider>
    )
}

export default SiteState
